export const AUTH_SET = 'AUTH_SET';
export const AUTH_CLEAR = 'AUTH_CLEAR';
export const USER_SET = 'USER_SET';
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const INCREMENT_ACTIVE_LOADING = 'INCREMENT_ACTIVE_LOADING';
export const DECREMENT_ACTIVE_LOADING = 'DECREMENT_ACTIVE_LOADING';